/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Downloading.
 * @export
 */
export const ICON_DOWNLOADING = (
  <svg fill="#000000" height="24px" viewBox="0 0 24 24" width="24px" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.33 3.55C16.39 2.95 15.34 2.51 14.21 2.25C13.59 2.11 13 2.59 13 3.23C13 3.68 13.3 4.1 13.74 4.2C14.65 4.4 15.51 4.76 16.27 5.25C16.66 5.5 17.16 5.42 17.49 5.09C17.94 4.64 17.87 3.89 17.33 3.55ZM20.77 11C21.41 11 21.9 10.41 21.75 9.79C21.49 8.67 21.05 7.62 20.45 6.67C20.11 6.13 19.35 6.06 18.9 6.51C18.58 6.83 18.5 7.34 18.74 7.73C19.23 8.5 19.59 9.35 19.79 10.26C19.9 10.7 20.31 11 20.77 11ZM18.9 17.49C19.35 17.94 20.11 17.87 20.45 17.34C21.05 16.4 21.49 15.35 21.75 14.23C21.89 13.61 21.4 13.02 20.77 13.02C20.32 13.02 19.9 13.32 19.8 13.76C19.6 14.67 19.23 15.52 18.75 16.29C18.5 16.66 18.58 17.17 18.9 17.49ZM13 20.77C13 21.41 13.59 21.9 14.21 21.75C15.33 21.49 16.38 21.05 17.32 20.45C17.86 20.11 17.93 19.35 17.48 18.9C17.16 18.58 16.65 18.5 16.27 18.75C15.51 19.24 14.66 19.6 13.74 19.8C13.3 19.9 13 20.31 13 20.77ZM13 12V8C13 7.45 12.55 7 12 7C11.45 7 11 7.45 11 8V12H9.41C8.52 12 8.07 13.08 8.7 13.71L11.29 16.3C11.68 16.69 12.31 16.69 12.7 16.3L15.29 13.71C15.92 13.08 15.47 12 14.58 12H13ZM11 20.77C11 21.41 10.41 21.9 9.79 21.76C5.33 20.75 2 16.77 2 12C2 7.23 5.33 3.25 9.79 2.25C10.41 2.11 11 2.59 11 3.23C11 3.69 10.69 4.1 10.24 4.2C6.67 5 4 8.19 4 12C4 15.81 6.67 19 10.24 19.8C10.69 19.9 11 20.31 11 20.77Z"
      fill="#707070"
    />
  </svg>
);
